import { createFileRoute } from "@tanstack/react-router";
import { MainLayout } from "@/components/layout/main-layout";

export const Route = createFileRoute("/_main")({
  beforeLoad: ({ location }) => {
    // Se estiver em uma página que deve ser fora do layout principal (tela cheia),
    // o roteador deveria ter usado a rota de nível superior, mas se caiu aqui,
    // garantimos que não haja efeitos colaterais.
    return;
  },
  component: MainLayout,
});